export const baseURL = process.env.URL ?? 'https://productioncrate.com'

// Add feature flags here
export const features = {
  favorites: false, // TODO: Get from env
}

export const CRATE_CORE_API_BASE_URL =
  process.env.NEXT_PUBLIC_CRATE_CORE_API_BASE_URL || 'https://rest.productioncrate.com'

export const LEGACY_API_BASE_URL =
  process.env.NEXT_PUBLIC_LEGACY_API_BASE_URL || 'https://d30upb8d426d8z.cloudfront.net'

export const SESSION_TOKEN_COOKIE_KEY = process.env.NEXT_PUBLIC_SESSION_TOKEN_COOKIE_KEY || 'newLogin'
export const REFRESH_TOKEN_COOKIE_KEY = process.env.NEXT_PUBLIC_REFRESH_TOKEN_COOKIE_KEY || 'newLogin_refresh'
export const SESSION_TOKEN_LOCAL_STORAGE_KEY = process.env.NEXT_PUBLIC_SESSION_TOKEN_LOCAL_STORAGE_KEY || 'token'
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY =
  process.env.NEXT_PUBLIC_REFRESH_TOKEN_LOCAL_STORAGE_KEY || 'refresh_token'

export const DEFAULT_TITLE = 'ProductionCrate - Make it Awesome.'
export const DEFAULT_DESCRIPTION =
  "Video Production Elements - Download exclusive video resources & spend less time in post. 1000's Of Original Production Elements, VFX, Original Music & More. Go PRO Now! 14-Day Free Trial. Download Our Mobile App. View Pricing Details. End-To-End Solutions. Request A Demo."
export const DEFAULT_IMAGE = `${baseURL}/img/ProductionCrate_Share_Graphic_FootageCrate_NoText.jpg`

export const MIN_HEADER_HEIGHT = 125

// When browsing multi-content assets, this sets the limit for each content
export const MULTI_CONTENT_ASSETS_LIMIT: number | undefined = process.env.MULTI_CONTENT_ASSETS_LIMIT
  ? parseInt(process.env.MULTI_CONTENT_ASSETS_LIMIT)
  : undefined

export const MEILISEARCH_HOST = process.env.NEXT_PUBLIC_MEILISEARCH_HOST || 'https://search.k8s.productioncrate.com'
export const MEILISEARCH_API_KEY = process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY || ''
export const MEILISEARCH_INDEX_PREFIX = process.env.NEXT_PUBLIC_MEILISEARCH_INDEX_PREFIX || ''

export const SITE_MAP_DOMAIN_VFX = process.env.SITE_MAP_DOMAIN_VFX || 'footagecrate.com'
export const SITE_MAP_DOMAIN_SFX = process.env.SITE_MAP_DOMAIN_SFX || 'soundscrate.com'
export const SITE_MAP_DOMAIN_GRAPHICS = process.env.SITE_MAP_DOMAIN_GRAPHICS || 'graphicscrate.com'
export const SITE_MAP_DOMAIN_3D = process.env.SITE_MAP_DOMAIN_3D || 'rendercrate.com'

export const BUILD_DATE = process.env.NEXT_PUBLIC_BUILD_DATE || new Date().toISOString()

export const SUBREQUEST_LIMIT = process.env.NEXT_PUBLIC_SUBREQUESTS_LIMIT
  ? parseInt(process.env.NEXT_PUBLIC_SUBREQUESTS_LIMIT)
  : undefined

export const DEFAULT_SEARCH_CATEGORY = process.env.NEXT_PUBLIC_DEFAULT_SEARCH_CATEGORY || 'all'

export const ASSETS_GRID_SCROLLER_ID = 'assets-grid-scroller'

export const HOVER_OTHERS_DIMMING_TIMEOUT = 1300
